module.exports = __webpack_public_path__ + "fonts/Yekan-Bakh-Medium.597c8017.woff";